export const SECTIONS = {
  PROPERTIES: "properties",
  MEDIA_LIBS: "media-libs",
  COACHES: "coaches",
  USERS: "users",
  MEMBERS: "members",
  CONTACTS: "contacts",
  EXPERIENCES: "experiences",
  MEDIA_ITEMS: "media-items",
  ICONS: "icons",
  UNIVERSITY: "university",
  ASSETS: "assets",
  ACCOUNTS: "accounts",
  ORGANIZATION_PROPERTIES: "organizationProperties",
  ORGANIZATION_USERS: "organizationUsers",
  ORGANIZATION_CONTACTS: "organizationContacts",
} as const;
